import React, { useEffect, useState } from 'react'
import { StyleSheet, css } from 'aphrodite'
import { Helper } from '../common/helpers/Helper'
import { AppUiHelper } from '../helpers/AppUiHelper'
import { layoutsTemplate } from '../data/data'
import LayoutPreview from './LayoutPreview'

const SelectTemplate = (props) => {
  const [layouts, setLayouts] = useState(layoutsTemplate)

  useEffect(() => {
    // Any side effects or initializations can go here
  }, [])

  const selectTemplate = (template) => {
    if (props && props.onSelectTemplate) props.onSelectTemplate(template)
  }

  return (
    <div className={css(Styles.inputsHolder)}>
      <div className={css(Styles.layoutGrid)}>
        {/* <div
          onClick={() => selectTemplate(null)}
          key={'custom'}
          className={css([Styles.layoutBox, Styles.customLayout])}
        >
          <div>
            <span className='material-icons-outlined'>add</span>
          </div>
          <div>{Helper.getString('makeCustomLayout')}</div>
        </div> */}
        {layouts.map((x) => {
          const maxWidth = 213
          const maxHeight = 120
          const landscapeSize = AppUiHelper.calculateRenderDimensions(x, maxWidth, maxHeight)
          const portraitSize = AppUiHelper.calculateRenderDimensions(x, maxWidth, maxHeight)
          return (
            <div
              onClick={() => selectTemplate(x)}
              key={x.id}
              className={css(Styles.layoutBox)}>
              {/* <LayoutPreview renderDimensions={{width:213, height: 213}} layoutJson={x} /> */}
              {x.orientation === 'PORTRAIT' && <LayoutPreview renderDimensions={portraitSize} layoutJson={x} />}
              {x.orientation === 'LANDSCAPE' && <LayoutPreview renderDimensions={landscapeSize} layoutJson={x} />}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default SelectTemplate

const Styles = StyleSheet.create({
  inputsHolder: {
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '16px',
    maxHeight: '40vh',
    overflowY: 'auto'
  },
  layoutGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: 28
  },
  layoutBox: {
    padding: '0px !important',
    textAlign: 'center !important',
    borderRadius: 6,
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center'
  },
  customLayout: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    boxShadow: '#ccc 0px 1px 5px 0px',
    alignItems: 'center',
    width: 213,
    height: 120
  }
})



// WEBPACK FOOTER //
// ./src/components/SelectTemplate.js